import { render, staticRenderFns } from "./AdminPois.vue?vue&type=template&id=21a06842&scoped=true"
import script from "./AdminPois.vue?vue&type=script&lang=js"
export * from "./AdminPois.vue?vue&type=script&lang=js"
import style0 from "./AdminPois.vue?vue&type=style&index=0&id=21a06842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a06842",
  null
  
)

export default component.exports